<lm-form-layout
    *ngIf="hasFieldLayout"
    [specFields]="specFields"
    [layout]="fieldLayout"
    [model]="model"
    [placeHolder]="placeHolder"
    [layoutInfo]="layoutInfo"
    (fieldEvent)="onFieldEvent($event)"
></lm-form-layout>

<lm-report-field-picker-button *ngIf="isCreateReportMode$ | async" [field]="field" [model]="model" [specFields]="specFields"></lm-report-field-picker-button>

<ng-container [ngSwitch]="layoutType">
  <lm-progress
      *ngSwitchCase="layoutEnum.PROGRESS"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-progress>
  <lm-rating
      *ngSwitchCase="layoutEnum.RATING"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [model]="model"
      [specFields]="specFields"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-rating>
  <lm-fileupload
      *ngSwitchCase="layoutEnum.BINARY_DOCUMENT"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-fileupload>
  <lm-checkbox
      *ngSwitchCase="layoutEnum.CHECKBOX"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-checkbox>
  <lm-checkboxgroup
      *ngSwitchCase="layoutEnum.CHECKBOXGROUP"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)">
  ></lm-checkboxgroup>
  <lm-text
      *ngSwitchCase="layoutEnum.PASSWORD"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-text>
  <lm-date
      *ngSwitchCase="layoutEnum.DATE"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-date>
  <lm-time
      *ngSwitchCase="layoutEnum.TIME"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-time>
  <lm-radiobutton
      *ngSwitchCase="layoutEnum.RADIO"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-radiobutton>
  <lm-dropdown
      *ngSwitchCase="layoutEnum.DROPDOWN"
      [layoutObject]="field"
      [mutexSpecField]="mutexSpecField"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-dropdown>
  <lm-text
      *ngSwitchCase="layoutEnum.ONE_LINE_TEXTAREA"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-text>
  <lm-process-indicator
      *ngSwitchCase="layoutEnum.PROCESS_INDICATOR"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [specFields]="specFields"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-process-indicator>
  <lm-textarea
      *ngSwitchCase="layoutEnum.MULTI_LINE_TEXTAREA"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-textarea>
  <lm-field-editor
      *ngSwitchCase="layoutEnum.FIELD_EDITOR"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-field-editor>
  <lm-field-editor-compare
      *ngSwitchCase="layoutEnum.FIELD_EDITOR_COMPARE"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-field-editor-compare>
  <lm-busclassfield
      *ngSwitchCase="layoutEnum.BUSCLASS_FIELD"
      [layoutObject]="field"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-busclassfield>
  <lm-richtext
      *ngSwitchCase="layoutEnum.RICH_TEXT"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [parentIsFormLayout]="parentIsFormLayout"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-richtext>
  <lm-lookup
      *ngSwitchCase="layoutEnum.LOOKUP"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-lookup>
  <lm-text
      #Field
      *ngSwitchCase="layoutEnum.TEXT"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-text>
  <lm-dropdown
      *ngSwitchCase="layoutEnum.MULTI_SELECT"
      [layoutObject]="field"
      [mutexSpecField]="mutexSpecField"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-dropdown>
  <lm-image
      *ngSwitchCase="layoutEnum.IMAGE"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      class="field"
  ></lm-image>
  <lm-manual-representation
      *ngSwitchCase="layoutEnum.MANUAL_REPRESENTATION"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      class="field"
  ></lm-manual-representation>
  <lm-text
      *ngSwitchCase="layoutEnum.COMPACT_FORMAT"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-text>
  <lm-compound-field
      *ngSwitchCase="layoutEnum.COMPACT_FORMAT_BY_FORM"
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      [previewMode]="field?.previewMode"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
  ></lm-compound-field>
  <lm-captcha-control *ngSwitchCase="layoutEnum.CAPTCHA_CONTROL">
  </lm-captcha-control>
</ng-container>
